<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>ID</th>
          <th>表示ステータス</th>
          <th>仕事概要</th>
          <th>申し込みURL</th>
          <th>勤務地(都道府県コード)</th>
          <th>給与_FROM</th>
          <th>給与_TO</th>
          <th>日本語レベルコード</th>
          <th>勤務時間1_FROM</th>
          <th>勤務時間1_TO</th>
          <th>勤務時間1_文言</th>
          <th>勤務時間2_FROM</th>
          <th>勤務時間2_TO</th>
          <th>勤務時間2_文言</th>
          <th>勤務時間3_FROM</th>
          <th>勤務時間3_TO</th>
          <th>勤務時間3_文言</th>
          <th>最寄駅1</th>
          <th>最寄駅1_文言</th>
          <th>最寄駅2</th>
          <th>最寄駅2_文言</th>
          <th>最寄駅3</th>
          <th>最寄駅3_文言</th>
          <th>その他条件/PR</th>
          <th>雇用形態</th>
          <th>登録日時</th>
          <th>更新日時</th>
        </tr>
        <tr v-for="(job, index) in this.jobs" :key="index">
          <td>{{ job.id }}</td>
          <td>{{ job.dispStatus }}</td>
          <td>{{ job.summary }}</td>
          <td>{{ job.applyUrl }}</td>
          <td>{{ job.prefCode }}</td>
          <td>{{ job.salaryFrom }}</td>
          <td>{{ job.salaryTo }}</td>
          <td>{{ job.japLevel }}</td>
          <td>{{ job.hour1F }}</td>
          <td>{{ job.hour1T }}</td>
          <td>{{ job.hour1W }}</td>
          <td>{{ job.hour2F }}</td>
          <td>{{ job.hour2T }}</td>
          <td>{{ job.hour2W }}</td>
          <td>{{ job.hour3F }}</td>
          <td>{{ job.hour3T }}</td>
          <td>{{ job.hour3W }}</td>
          <td>{{ job.nearSta1 }}</td>
          <td>{{ job.nearSta1W }}</td>
          <td>{{ job.nearSta2 }}</td>
          <td>{{ job.nearSta2W }}</td>
          <td>{{ job.nearSta3 }}</td>
          <td>{{ job.nearSta3W }}</td>
          <td>{{ job.other}}</td>
          <td>{{ job.empTypeName }}</td>
          <td>{{ job.createdAt }}</td>
          <td>{{ job.updatedAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from '@/constants/MasterEnum'
import firebase from 'firebase'
import utils from '@/utils/Utils'

export default {
  name : "jobsInfo",
  mixins: [
    utils,
    master
  ],
  data () {
    return {
      loading : false,
      db : firebase.firestore(),
      jobs : [],
    }
  },
  props : {
    firstDate : {
      type : Date,
      required : true,
    },
    lastDate : {
      type : Date,
      required : true,
    }
  },
  created: function() {
    this.loading = true;
      this.db.collection("jobs")
      .orderBy('created_at', 'asc')
      .startAt(this.firstDate)
      .endAt(this.lastDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          var data = doc.data();
          this.jobs.push({
            id : doc.id,
            dispStatus : this.escapeNull(data.display_status),
            summary : this.escapeNull(data.summary),
            applyUrl : this.escapeNull(data.apply_url),
            prefCode : this.escapeNull(data.pref_code),
            salaryFrom : this.escapeNull(data.salary_from),
            salaryTo : this.escapeNull(data.salary_to),
            japLevel: this.escapeNull(data.japanese_level_code),
            hour1F : this.escapeNull(data.working_hours1_from),
            hour1T : this.escapeNull(data.working_hours1_to),
            hour1W : this.escapeNull(data.working_hours1_word),
            hour2F : this.escapeNull(data.working_hours2_from),
            hour2T : this.escapeNull(data.working_hours2_to),
            hour2W : this.escapeNull(data.working_hours2_word),
            hour3F : this.escapeNull(data.working_hours3_from),
            hour3T : this.escapeNull(data.working_hours3_to),
            hour3W : this.escapeNull(data.working_hours3_word),
            nearSta1 : this.escapeNull(data.nearrest_station1),
            nearSta1W : this.escapeNull(data.nearrest_station1_word),
            nearSta2 : this.escapeNull(data.nearrest_station2),
            nearSta2W : this.escapeNull(data.nearrest_station2_word),
            nearSta3 : this.escapeNull(data.nearrest_station3),
            nearSta3W : this.escapeNull(data.nearrest_station3_word),
            other : this.escapeNull(data.other),
            empTypeName : this.escapeNull(data.employment_type_name),
            createdAt : this.formatDateTime((data.created_at).toDate()),
            updatedAt : this.formatDateTime((data.updated_at).toDate()),
          });
        });
      })
      .then(() => {
        this.loading = false;
        this.$emit('bind-event' , this.jobs , this.tsvFormat.jobsInfo.fileName, this.tsvFormat.jobsInfo.labels);
      });
  }

}
</script>
